<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('writeOff.pageTitle') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('writeOff.pageTitle'),
            href: '/admin/write-offs'
          },
          {
            text: $t('edit'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="ready_fetch || saving || savePreviewing">
          <form class="form-horizontal">
            <div class="row mb-3">
              <div class="col-sm-12 col-lg-6 col-md-12">
                <div class="form-group row">
                  <label class="col-md-4 form-col-label control-label required">
                    {{ $t('writeOff.date') }}
                  </label>
                  <div class="col-md-7">
                    <ts-date-picker-input
                      v-model="model.write_off_date"
                      :closeOnSelect="true"
                    ></ts-date-picker-input>
                    <div class="validate" v-if="errors.has('write_off_date')">
                      {{ errors.first('write_off_date') }}
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-md-4 form-col-label control-label required">
                    {{ $t('writeOff.reason') }}</label
                  >
                  <div class="col-md-7">
                    <textarea
                      v-model="model.write_off_reason"
                      class="form-control"
                      :class="{
                        'is-invalid': errors.has('write_off_reason')
                      }"
                    ></textarea>
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('write_off_reason')"
                    >
                      {{ errors.first('write_off_reason') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="row">
            <div class="col-md-12">
              <div class="ts-border ts-border-gray-300 ts-p-3 ts-rounded">
                <SearchBox
                  v-model="fetchOptions"
                  :waiting="fetchingProduct"
                  @onEnter="fetchProduct"
                />
                <b-alert
                  ref="success"
                  variant="success"
                  :show="success_message.length > 0"
                  dismissible
                >
                  <ul class="ts-list-disc">
                    <li
                      v-for="(message, index) in success_message"
                      :key="index"
                    >
                      {{ message }}
                    </li>
                  </ul>
                </b-alert>
                <b-alert
                  ref="info"
                  variant="info"
                  :show="info_message.length > 0"
                  dismissible
                >
                  <ul class="ts-list-disc">
                    <li v-for="(message, index) in info_message" :key="index">
                      {{ message }}
                    </li>
                  </ul>
                </b-alert>
                <b-alert
                  ref="danger"
                  variant="danger"
                  :show="error_message.length > 0"
                  dismissible
                >
                  <ul class="ts-list-disc">
                    <li v-for="(message, index) in error_message" :key="index">
                      {{ message }}
                    </li>
                  </ul>
                </b-alert>
                <div class="ts-h-64 ts-mt-3 ts-rounded ts-overflow-y-scroll">
                  <ts-loading-banner :loading="fetchingProduct">
                    <div class="container-product">
                      <table class="ts-w-full product-table" id="product-table">
                        <thead>
                          <tr>
                            <th
                              class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3 "
                              style="width: 14%"
                            >
                              {{ $t('writeOff.barcode') }}
                            </th>
                            <th
                              class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3 "
                              style="width: 14%"
                            >
                              {{ $t('writeOff.productGroup') }}
                            </th>
                            <th
                              class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3"
                            >
                              {{ $t('writeOff.product') }}
                            </th>
                            <th
                              class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3 text-center"
                              style="width: 9%"
                            >
                              {{ $t('writeOff.uom') }}
                            </th>
                            <th
                              class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3 text-center"
                              style="width: 9%"
                            >
                              {{ $t('writeOff.availableQuantity') }}
                            </th>
                            <th
                              class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3 text-center"
                              style="width: 9%"
                            >
                              {{ $t('writeOff.quantity') }}
                            </th>
                            <th
                              class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3"
                            >
                              {{ $t('writeOff.remarks') }}
                            </th>
                            <th
                              class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3 text-center ts-whitespace-no-wrap"
                              style="width: 3%"
                            >
                              <a
                                class="text-primary"
                                @click.prevent="manualAdd"
                                v-tooltip="$t('writeOff.addProduct')"
                              >
                                <i
                                  class="fas fa-spinner spin"
                                  v-if="ready_fetch"
                                ></i>
                                <i class="fa fa-plus" v-else></i>
                              </a>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item, index) in model.sub_item_list"
                            :key="index"
                          >
                            <td
                              class="ts-py-1 ts-px-3"
                              :class="{
                                'selected-class': item.product_id == product_id
                              }"
                            >
                              {{ getProdcutById(item.product_id).barcode }}
                            </td>
                            <td
                              class="ts-py-1 ts-px-3"
                              :class="{
                                'selected-class': item.product_id == product_id
                              }"
                            >
                              {{
                                getProdcutById(item.product_id).group
                                  .pro_group_name_en
                              }}
                            </td>
                            <td
                              class="ts-py-1 ts-px-3"
                              :class="{
                                'selected-class': item.product_id == product_id
                              }"
                            >
                              {{
                                getProdcutById(item.product_id).product_name_en
                              }}
                            </td>
                            <td
                              class="ts-py-1 ts-px-3 text-center"
                              :class="{
                                'selected-class': item.product_id == product_id
                              }"
                            >
                              {{ getUomNameById(item.uom_id) }}
                            </td>
                            <td
                              class="ts-py-1 text-center"
                              :class="{
                                'selected-class': item.product_id == product_id
                              }"
                            >
                              <input
                                type="number"
                                disabled
                                v-model.number="item.available_quantity"
                                step="any"
                                class="form-control only-border-bottom"
                              />
                            </td>
                            <td
                              class="ts-py-1 text-center"
                              :class="{
                                'selected-class': item.product_id == product_id
                              }"
                            >
                              <input
                                v-if="item.serial_no.length > 0"
                                :disabled="item.serial_no.length > 0"
                                type="number"
                                v-model.number="item.quantity"
                                step="any"
                                class="form-control only-border-bottom"
                                :class="{
                                  'is-invalid': errors.has(
                                    'sub_item_list.' + index + '.quantity'
                                  )
                                }"
                              />
                              <input
                                v-else
                                :disabled="item.serial_no.length > 0"
                                type="number"
                                v-model.number="item.quantity"
                                step="any"
                                @keypress.enter="onCountQtyEnter(index)"
                                ref="quantity"
                                class="form-control only-border-bottom"
                                :class="{
                                  'is-invalid': errors.has(
                                    'sub_item_list.' + index + '.quantity'
                                  )
                                }"
                              />
                            </td>
                            <td
                              class="ts-py-1 text-center"
                              :class="{
                                'selected-class': item.product_id == product_id
                              }"
                            >
                              <input
                                @keypress.enter="onRemarkEnter(index)"
                                ref="remark"
                                type="text"
                                v-model="item.remarks"
                                step="any"
                                class="form-control only-border-bottom text-left"
                              />
                            </td>
                            <td
                              :class="{
                                'selected-class': item.product_id == product_id
                              }"
                              class="text-center"
                            >
                              <a-popconfirm
                                placement="leftTop"
                                :title="$t('are_you_sure_to_delete')"
                                :ok-text="$t('yes')"
                                :cancel-text="$t('no')"
                                @confirm="removeRow(item)"
                              >
                                <a href="#" v-tooltip="$t('delete')">
                                  <i class="fa fa-trash mr-2 text-red"></i>
                                </a>
                              </a-popconfirm>
                              <a
                                v-show="item.serial_no.length > 0"
                                href="#"
                                v-tooltip="$t('writeOff.showSerial')"
                                class="text-info"
                                @click.prevent="show(item)"
                              >
                                <i class="fas fa-align-justify"></i>
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </ts-loading-banner>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-12 ts-flex ts-justify-end ts-space-x-3">
              <ts-button
                class="btn-default"
                @click="$router.push({ name: 'write-off' })"
              >
                {{ $t('cancel') }}
              </ts-button>
              <ts-button
                color="primary"
                @click.prevent="update"
                :waiting="saving"
                v-if="model.sub_item_list.length"
              >
                {{ $t('update') }}
              </ts-button>
            </div>
          </div>
        </ts-loading-banner>
      </ts-card-wrapper>
      <a-modal
        :title="$t('writeOff.availableSerial')"
        width="45%"
        v-model="show_serial"
        :footer="null"
        @cancel="handleCancel"
      >
        <div class="ts-border ts-border-gray-300 ts-p-3 ts-rounded">
          <a-tabs :default-active-key="1" @change="callback1" class="ts-mb-3">
            <a-tab-pane :key="1" :tab="$t('writeOff.byRange')">
              <div class="ts-flex" v-if="activeTab1 == 1">
                <div class="ts-flex-1">
                  <input
                    v-model="from_serial"
                    type="text"
                    class="form-control"
                    :placeholder="$t('writeOff.fromSerial')"
                  />
                </div>
                <div class="ts-flex-1 ts-text-center">
                  <i class="fas fa-arrow-right fa-2x"></i>
                </div>
                <div class="ts-flex-1">
                  <input
                    v-model="to_serial"
                    type="text"
                    class="form-control"
                    :placeholder="$t('writeOff.toSerial')"
                  />
                </div>
                <div class="ts-flex-1 ts-text-right">
                  <ts-button outline color="primary" @click.prevent="submit">
                    {{ $t('writeOff.submit') }}
                  </ts-button>
                </div>
              </div>
            </a-tab-pane>
            <a-tab-pane :key="2" :tab="$t('writeOff.byScan')">
              <SearchBox v-model="searchSerial" v-if="activeTab1 == 2" />
            </a-tab-pane>
          </a-tabs>
          <div class="ts-mt-3 ts-h-64 ts-rounded ts-overflow-y-scroll">
            <div class="container-product">
              <table class="ts-w-full product-table" id="product-table">
                <thead>
                  <tr>
                    <th
                      class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3 "
                      style="width: 14%"
                    >
                      {{ $t('writeOff.barcode') }}
                    </th>
                    <th class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3">
                      {{ $t('writeOff.product') }}
                    </th>
                    <th
                      class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3 text-center"
                      style="width: 9%"
                    >
                      {{ $t('writeOff.uom') }}
                    </th>
                    <th
                      class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3 text-center"
                      style="width: 9%"
                    >
                      {{ $t('writeOff.serial') }}
                    </th>
                    <th
                      class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3 text-center"
                      style="width: 1%"
                      v-if="activeTab1 == 2"
                    >
                      {{ $t('actions') }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(serial, index) in serialResource" :key="index">
                    <td class="ts-py-1 ts-px-3 ts-whitespace-no-wrap">
                      {{ getProdcutById(show_detial_item.product_id).barcode }}
                    </td>
                    <td class="ts-py-1 ts-px-3 ts-whitespace-no-wrap">
                      {{
                        getProdcutById(show_detial_item.product_id)
                          .product_name_en
                      }}
                    </td>
                    <td
                      class="ts-py-1 ts-px-3 text-center ts-whitespace-no-wrap"
                    >
                      {{ getUomNameById(show_detial_item.uom_id) }}
                    </td>
                    <td
                      class="ts-py-1 ts-px-3 text-center ts-whitespace-no-wrap"
                    >
                      {{ serial }}
                    </td>
                    <td class="text-center" v-if="activeTab1 == 2">
                      <a-popconfirm
                        placement="leftTop"
                        :title="$t('are_you_sure_to_delete')"
                        :ok-text="$t('yes')"
                        :cancel-text="$t('no')"
                        @confirm="removeSerial(serial)"
                      >
                        <a href="#">
                          <i class="fa fa-trash mr-2 text-red"></i>
                        </a>
                      </a-popconfirm>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="ts-mt-4 ts-text-right ts-font-bold" v-if="activeTab1 == 1">
          TOTAL : {{ serialResource.length }}
        </div>
        <div class="ts-mt-4 ts-text-right ts-font-bold" v-else>
          TOTAL : {{ !isEmpty ? show_detial_item.serial_no.length : 0 }}
        </div>
      </a-modal>
      <a-modal
        v-if="show_manual_add"
        v-model="show_manual_add"
        :title="$t('writeOff.addProduct')"
        :footer="null"
        :centered="true"
        :zIndex="1020"
        :maskClosable="false"
        width="800px"
      >
        <Manual
          v-model="model"
          @close="() => ((show_manual_add = false), (product_id = ''))"
        />
      </a-modal>
      <a-modal
        :title="$t('writeOff.escapedSerial')"
        width="500px"
        v-model="show_escaped_serial"
        :footer="null"
        @cancel="handleCancel"
      >
        <div class="ts-border ts-border-gray-300 ts-p-3 ts-rounded">
          <SearchBoxSerial
            v-model="serialForEscap"
            :waiting="fetchEscap"
            @onEnter="fetchSerialForEscap"
          />
          <div class="ts-mt-3 ts-h-64 ts-rounded ts-overflow-y-scroll">
            <table class="ts-w-full">
              <thead>
                <tr>
                  <th
                    class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3 "
                    style="width: 14%"
                  >
                    {{ $t('writeOff.barcode') }}
                  </th>
                  <th class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3">
                    {{ $t('writeOff.group') }}
                  </th>
                  <th class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3">
                    {{ $t('writeOff.product') }}
                  </th>
                  <th class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3">
                    {{ $t('writeOff.status') }}
                  </th>
                  <th
                    class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3 text-center"
                    style="width: 9%"
                  >
                    {{ $t('writeOff.serial') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(serial, index) in serial_escap_item.serial_no"
                  :key="index"
                >
                  <td class="ts-py-1 ts-px-3 ts-whitespace-no-wrap">
                    {{ data.product.barcode }}
                  </td>
                  <td class="ts-py-1 ts-px-3 ts-whitespace-no-wrap">
                    {{ data.product.pro_group_name_en }}
                  </td>
                  <td class="ts-py-1 ts-px-3 ts-whitespace-no-wrap">
                    {{ data.product.product_name_en }}
                  </td>
                  <td class="ts-py-1 ts-px-3 ts-whitespace-no-wrap">
                    <span
                      :class="'text-' + serialStatusStyle(serial.sn_status_id)"
                      >{{
                        serial.serial_status
                          ? serial.serial_status.sn_status
                          : ''
                      }}</span
                    >
                  </td>
                  <td class="ts-py-1 ts-px-3 text-center ts-whitespace-no-wrap">
                    {{ serial.serial_no }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import SearchBox from './components/search-box'
import SearchBoxSerial from './components/search-box-serial'
import Manual from './components/manual-add.vue'

export default {
  name: 'writeOffEdit',
  components: {
    SearchBox,
    Manual,
    SearchBoxSerial
  },
  data () {
    return {
      show_manual_add: false,
      activeTab: 1,
      activeTab1: 1,
      from_serial: '',
      to_serial: '',
      errors: new Errors(),
      ready_fetch: false,
      saving: false,
      savePreviewing: false,
      show_serial: false,
      product_id: null,
      waiting: false,
      fetchingProduct: false,
      main_products: [],
      success_message: [],
      info_message: [],
      error_message: [],
      show_detial_item: {},
      products_available: [],
      fetchOptions: {
        search_value: ''
      },
      searchSerial: {
        search_value: ''
      },
      serialForEscap: {
        search_value: ''
      },
      category_id: '',
      product_available_id: '',
      show_escaped_serial: false,
      serial_escap_item: {},
      escaped_serial_no: [],
      fetchEscap: false,
      model: {
        write_off_date: moment().format('DD-MM-YYYY'),
        write_off_reason: '',
        ref_stock_in_id: null,
        sub_item_list: [],
        sub_item_list_by_serial_range: []
      },
      item: {
        product_id: '',
        uom_id: '',
        cost: 0,
        quantity: null,
        available_quantity: null,
        max_serial_no: '',
        min_serial_no: '',
        serial_no: []
      }
    }
  },
  computed: {
    ...mapState('stock/writeOff', [
      'products',
      'uom',
      'categoryAvailable',
      'productAvailable',
      'stockInNumbers',
      'edit_data'
    ]),
    ...mapGetters('stock/writeOff', ['getProdcutById', 'getUomNameById']),
    serialResource () {
      if (_.isEmpty(this.show_detial_item)) return []

      if (this.searchSerial.search_value) {
        return _.orderBy(this.show_detial_item.serial_no, [], ['asc']).filter(
          s =>
            s
              .toLowerCase()
              .indexOf(this.searchSerial.search_value.toLowerCase()) != -1
        )
      }
      if (this.from_serial && !this.to_serial) {
        return _.orderBy(
          _.filter(
            this.show_detial_item.serial_no,
            serial_no => serial_no >= this.from_serial
          ),
          [],
          ['asc']
        )
      }
      if (!this.from_serial && this.to_serial) {
        return _.orderBy(
          _.filter(
            this.show_detial_item.serial_no,
            serial_no => serial_no <= this.to_serial
          ),
          [],
          ['asc']
        )
      }
      if (this.from_serial && this.to_serial) {
        return _.orderBy(
          _.filter(
            this.show_detial_item.serial_no,
            serial_no =>
              serial_no >= this.from_serial && serial_no <= this.to_serial
          ),
          [],
          ['asc']
        )
      }
      return _.orderBy(this.show_detial_item.serial_no, [], ['asc'])
    },
    productAvailables () {
      if (this.category_id) {
        return _.orderBy(this.productAvailable, ['product_name']).filter(
          p => p.category_id == this.category_id
        )
      }
      return _.orderBy(this.productAvailable, ['product_name'])
    },
    isEmpty () {
      return _.isEmpty(this.show_detial_item)
    }
  },
  created () {
    this.fetchResourceBeforeCreate()
  },
  methods: {
    ...mapActions('stock/writeOff', ['availableQuantity']),
    setEditData () {
      this.model = {
        write_off_id: this.edit_data.write_off_id,
        write_off_date: this.edit_data.write_off_date,
        write_off_reason: this.edit_data.write_off_reason,
        sub_item_list: []
      }
      this.edit_data.write_off_details.forEach(detail => {
        this.availableQuantity(detail.product_id).then(response => {
          this.model.sub_item_list.push({
            write_off_id: detail.write_off_id,
            product_id: detail.product_id,
            quantity: detail.quantity,
            available_quantity:
              parseInt(response.data.ending_balance) +
              parseInt(detail.quantity),
            cost: detail.cost,
            uom_id: detail.uom_id,
            serial_no: detail.write_off_detail_serial.map(serial => {
              return serial.serial_no
            })
          })
        })
      })
    },
    fetchResourceBeforeCreate () {
      this.ready_fetch = true
      this.$store
        .dispatch('stock/writeOff/dataBeforeCreate')
        .then(() => {
          this.setEditData()
        })
        .catch(error => {
          this.ready_fetch = false
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.ready_fetch = false
        })
    },
    fetchProduct () {
      this.fetchingProduct = true
      this.$store
        .dispatch('stock/writeOff/getProductSearch', this.fetchOptions)
        .then(response => {
          if (response.length) {
            this.scanBarcode(response[0])
          } else {
            this.onClickProduct(response)
          }
        })
        .finally(() => {
          this.fetchingProduct = false
        })
    },
    fetchProductAvailable () {
      this.errors = new Errors()
      this.fetchingProduct = true
      this.$store
        .dispatch(
          'stock/writeOff/getProductAvailableSearch',
          Object.assign(
            {},
            {
              stock_in_id: this.model.ref_stock_in_id,
              category_id: this.category_id ? this.category_id : 0,
              product_id: this.product_available_id
                ? this.product_available_id
                : 0
            }
          )
        )
        .then(response => {
          this.products_available = response
          this.addToList()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.fetchingProduct = false
        })
    },
    addToList (e) {
      this.products_available.map(el => {
        let checkItem = this.model.sub_item_list_by_serial_range
          .filter(s => s.product_id == el.product_id && s.uom_id == el.uom_id)
          .reduce((init, value) => (init = value), {})
        if (!_.isEmpty(checkItem)) {
          // move product to first index
          this.model.sub_item_list_by_serial_range.sort(function (x, y) {
            return x == checkItem ? -1 : y == checkItem ? 1 : 0
          })
        } else {
          this.item = {
            product_id: el.product_id,
            uom_id: el.uom_id,
            cost: 0,
            available_quantity: el.available_quantity,
            max_serial_no: el.max_serial_no,
            min_serial_no: el.min_serial_no,
            quantity: el.available_quantity,
            serial_no: []
          }
          this.$forceUpdate()
          this.model.sub_item_list_by_serial_range.unshift(_.clone(this.item))
        }
      })
    },
    fetchSerialForEscap () {
      this.fetchEscap = true
      this.$store
        .dispatch('stock/writeOff/getProductSearch', this.serialForEscap)
        .then(response => {
          this.onClickEscap(response.data[0])
        })
        .finally(() => {
          this.fetchEscap = false
        })
    },
    onClickEscap (product) {
      if (product) {
        if (
          this.serial_escap_item.product_id == product.product_id &&
          this.serial_escap_item.uom_id == product.uom_id
        ) {
          let serialExist = this.escaped_serial_no.filter(
            serial_no => serial_no == product.serial_no
          )
          if (serialExist.length <= 0) {
            this.escaped_serial_no.push(product.serial_no)
          } else {
            this.$toasted.info('This serial number already exist.')
          }
        }
      }
    },
    submit () {
      this.success_message = []
      this.info_message = []
      this.error_message = []
      if (this.show_detial_item) {
        let checkItem = this.model.sub_item_list
          .filter(
            s =>
              s.product_id == this.show_detial_item.product_id &&
              s.uom_id == this.show_detial_item.uom_id
          )
          .reduce((init, value) => (init = value), {})

        if (!_.isEmpty(checkItem)) {
          let excludeSerials = _.difference(
            checkItem.serial_no,
            this.serialResource
          )
          if (excludeSerials.length > 0) {
            let newSerial = this.serialResource
            checkItem.serial_no = []
            newSerial.map(serial => checkItem.serial_no.unshift(serial))
            checkItem.quantity = checkItem.serial_no.length
            this.from_serial = ''
            this.to_serial = ''
            this.searchSerial.search_value = ''
            this.show_serial = false
            this.$refs.info.localShow = true
            this.info_message.push(
              'Selected ' +
                newSerial.length +
                ' serial numbers were added to product: ' +
                this.getProdcutById(this.show_detial_item.product_id)
                  .product_name_en +
                '; Others were removed.'
            )
          } else {
            this.from_serial = ''
            this.to_serial = ''
            this.searchSerial.search_value = ''
            this.show_serial = false
          }
        }

        // move product to first index
        this.model.sub_item_list.sort(function (x, y) {
          return x == checkItem ? -1 : y == checkItem ? 1 : 0
        })
      }
    },
    scanBarcode (pro) {
      let product = this.products
        .filter(p => p.product_id == pro.product_id)
        .reduce((init, value) => (init = value), null)
      if (!product) {
        this.product_id = null
        this.$toasted.info(
          'Product not found! Please verify serial number or barcode.'
        )
        return
      }
      this.product_id = product.product_id
      let checkItem = this.model.sub_item_list
        .filter(
          p => p.product_id == product.product_id || p.uom_id == product.uom_id
        )
        .reduce((init, value) => (init = value), {})
      if (_.isEmpty(checkItem)) {
        this.model.sub_item_list.unshift({
          product_id: product.product_id,
          quantity: pro.ending_balance,
          available_quantity: pro.ending_balance,
          uom_id: product.uom_category.unit_of_measures
            .filter(u => u.is_default == true)
            .reduce((init, value) => (init = value.uom_id), null),
          cost: 0,
          serial_no: []
        })
      } else {
        checkItem.quantity = checkItem.quantity + 1
      }
      // move product to first index
      this.model.sub_item_list.sort(function (x, y) {
        return x == checkItem ? -1 : y == checkItem ? 1 : 0
      })
      this.fetchOptions.search_value = ''
    },
    onClickProduct (product) {
      this.success_message = []
      this.info_message = []
      this.error_message = []
      if (product) {
        this.product_id = product.product_id
        let p = this.products
          .filter(p => p.product_id == product.product_id)
          .reduce((init, value) => (init = value), null)
        if (!p) {
          this.product_id = null
          this.$toasted.info(
            'Product not found! Please verify serial number or barcode.'
          )
          return
        }
        this.model.ref_stock_in_id = product.ref_stock_in_id
        this.item = {
          product_id: p.product_id,
          uom_id: product.uom_id,
          quantity: 1,
          available_quantity: product.ending_balance,
          cost: 0,
          serial_no: []
        }
        let checkItem = this.model.sub_item_list
          .filter(
            s =>
              s.product_id == this.item.product_id &&
              s.uom_id == this.item.uom_id
          )
          .reduce((init, value) => (init = value), {})
        if (!_.isEmpty(checkItem)) {
          let serialExist = checkItem.serial_no.filter(
            serial_no => serial_no == product.serial_no
          )
          if (serialExist.length <= 0) {
            checkItem.serial_no.push(product.serial_no)
            checkItem.quantity = checkItem.serial_no.length
          } else {
            this.$toasted.info('This serial number already exist.')
          }
          // move product to first index
          this.model.sub_item_list.sort(function (x, y) {
            return x == checkItem ? -1 : y == checkItem ? 1 : 0
          })
          this.$forceUpdate()
        } else {
          this.item.serial_no.unshift(product.serial_no)
          this.$forceUpdate()
          this.model.sub_item_list.unshift(_.clone(this.item))
        }
        this.fetchOptions.search_value = ''
      } else {
        let product = this.products
          .filter(p => p.barcode == this.fetchOptions.search_value)
          .reduce((init, value) => (init = value), null)
        if (!product) {
          this.product_id = null
          this.$toasted.info(
            'Product not found! Please verify serial number or barcode.'
          )
          return
        }
        this.product_id = product.product_id
        let checkItem = this.model.sub_item_list
          .filter(
            p =>
              p.product_id == product.product_id || p.uom_id == product.uom_id
          )
          .reduce((init, value) => (init = value), {})
        if (_.isEmpty(checkItem)) {
          this.model.sub_item_list.unshift({
            product_id: product.product_id,
            uom_id: product.uom_category.unit_of_measures
              .filter(u => u.is_default == true)
              .reduce((init, value) => (init = value.uom_id), null),
            quantity: 1,
            cost: 0,
            serial_no: []
          })
        } else {
          checkItem.quantity = checkItem.quantity + 1
        }
        // move product to first index
        this.model.sub_item_list.sort(function (x, y) {
          return x == checkItem ? -1 : y == checkItem ? 1 : 0
        })
        this.fetchOptions.search_value = ''
      }
    },
    removeRow (item) {
      this.model.sub_item_list.splice(this.model.sub_item_list.indexOf(item), 1)
    },
    removeSerialRangeRow (item) {
      this.model.sub_item_list_by_serial_range.splice(
        this.model.sub_item_list_by_serial_range.indexOf(item),
        1
      )
    },
    removeSerial (serial) {
      let checkItem = this.model.sub_item_list
        .filter(
          p =>
            p.product_id == this.show_detial_item.product_id &&
            p.uom_id == this.show_detial_item.uom_id
        )
        .reduce((init, value) => (init = value), null)

      if (!_.isEmpty(checkItem)) {
        if (checkItem.serial_no.length == 1) {
          checkItem.serial_no.splice(
            this.show_detial_item.serial_no.indexOf(serial),
            1
          )
          this.model.sub_item_list.splice(
            this.model.sub_item_list.indexOf(checkItem),
            1
          )
        } else {
          checkItem.serial_no.splice(
            this.show_detial_item.serial_no.indexOf(serial),
            1
          )
          checkItem.quantity = checkItem.serial_no.length
        }
        this.product_id = checkItem.product_id
        // move product to first index
        this.model.sub_item_list.sort(function (x, y) {
          return x == checkItem ? -1 : y == checkItem ? 1 : 0
        })
      }
    },
    countSerial (serial) {
      return _.keys(serial).length
    },
    update () {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('stock/writeOff/update', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.saving = false
          this.$router.push({ name: 'write-off' })
        })
        .catch(error => {
          this.saving = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },
    clearInput () {
      this.model = {
        write_off_date: moment().format('DD-MM-YYYY'),
        write_off_reason: '',
        ref_stock_in_id: null,
        sub_item_list: [],
        sub_item_list_by_serial_range: []
      }
    },
    show (item) {
      this.show_serial = true
      this.show_detial_item = item
    },
    escapedSerial (item) {
      this.show_escaped_serial = true
      this.serial_escap_item = item
    },
    handleCancel (e) {
      this.show_serial = false
    },
    callback (key) {
      this.activeTab = key
      this.model.sub_item_list = []
      this.model.sub_item_list_by_serial_range = []
    },
    callback1 (key) {
      this.from_serial = ''
      this.to_serial = ''
      this.searchSerial.search_value = ''
      this.activeTab1 = key
    },
    manualAdd () {
      this.show_manual_add = true
    },
    select (index) {
      this.$refs.quantity[index].select()
    },
    onSerialQtyEnter (index) {
      if (index + 1 < this.model.sub_item_list_by_serial_range.length) {
        this.$refs.quantity[index + 1].focus()
        this.$refs.quantity[index + 1].select()
      } else {
        this.$refs.quantity[0].focus()
        this.$refs.quantity[0].select()
      }
    },
    getSerialByQty (item, index) {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.serialByQty(item, index)
      }, 800)
    },
    serialByQty (item, index) {
      if (item.quantity) {
        this.$store
          .dispatch('stock/writeOff/getNewSerialByQty', item)
          .then(response => {
            if (item.quantity > response[0].avialable_quantity) {
              // item.quantity = response[0].avialable_quantity
            }
            item.min_serial_no = response[0].min_serial_no
            item.max_serial_no = response[0].max_serial_no
          })
          .finally(() => {
            this.fetchEscap = false
          })
      }
    },
    onChangeStockIn () {
      if (!this.model.ref_stock_in_id) return
      this.$store.dispatch(
        'stock/writeOff/getCategoryAvailable',
        Object.assign(
          {},
          {
            stock_in_id: this.model.ref_stock_in_id
          }
        )
      )
      this.$store.dispatch(
        'stock/writeOff/getProductAvailable',
        Object.assign(
          {},
          {
            stock_in_id: this.model.ref_stock_in_id
          }
        )
      )
    }
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('stock/writeOff/RESET_STATE')
    next()
  }
}
</script>
<style lang="css" scoped>
#container-product {
  height: 70px;
}

::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: transparent; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #f0f3f4;
}
::-webkit-scrollbar-thumb:hover {
  background: #dddedf;
}
#product-table > thead > tr > th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  /* z-index: 9; */
  padding: 7px;
  border-bottom: none !important;
}
.selected-class {
  border-bottom: 1px solid #69bafb;
  border-top: 1px solid #69bafb;
  background: #e9f1f8;
}

#product-table > tbody > tr > td {
  cursor: pointer;
}
.line {
  border: 0;
  background-color: rgb(131, 129, 129);
  height: 2px;
  cursor: pointer;
}
.w-fit {
  width: fit-content;
}
.max-h {
  max-height: 300px;
  overflow: scroll;
}
.alert {
  margin-bottom: 2px !important;
}
.ts-list-disc {
  margin-left: 20px;
}
ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 0rem;
}
.only-border-bottom {
  border-top: none;
  border-left: none;
  border-right: none;
  outline: none;
  text-align: center;
  -webkit-box-shadow: none;
  box-shadow: none;
  font-size: 12px;
  line-height: 1.42857143;
  height: 25px;
  padding: 2px 4px;
}
.ts-h-64 {
  height: 20rem;
}
</style>
